import { FC, Fragment } from 'react';
import { Text } from '@doda/io-react/common';
import styles from './index.module.scss';

/**
 * 関連リンク用リンクリスト
 */
export interface LinkList {
  separator?: string;
  list: {
    href: string;
    text: string;
    count?: number;
    childList?: LinkList;
  }[];
}

/**
 * LinkListのprops
 */
interface Props {
  linkList: LinkList;
}

/**
 * 関連リンクのリスト
 * @param separator 要素間に表示する文字列
 * @param list 表示するリスト
 */
export const LinkList: FC<Props> = ({ linkList: { list, separator } }) => {
  return (
    <ul className={styles['jobSearchDetail-relationLink__list']}>
      {list.map(({ href, text, count, childList }) => (
        <Fragment key={`${text}${href}`}>
          <li
            className={styles['jobSearchDetail-relationLink__listItem']}
            data-separator={separator}
          >
            <a
              className={styles['jobSearchDetail-relationLink__link']}
              href={href}
              rel={count === 1 ? 'nofollow' : undefined}
            >
              <Text as="span" color="blue">
                {text}
              </Text>
            </a>
          </li>
          {childList && (
            <li
              className={styles['jobSearchDetail-relationLink__listItem']}
              data-separator={separator}
            >
              <LinkList linkList={childList} />
            </li>
          )}
        </Fragment>
      ))}
    </ul>
  );
};
